import axios from "axios";
import { Box, DataGrid, Popup } from "devextreme-react";
import { Item } from "devextreme-react/box";
import CustomStore from "devextreme/data/custom_store";
import { useState } from "react";
import BillingTimingGrid from "./BillingTimingGrid";
import CommentGrid from "./CommentGrid";

export default function AOSPTCBillingTiming(props) {
  const {
    AOSPTCBillingTimingPopupVisible,
    setAOSPTCBillingTimingPopupVisible,
  } = props;

  const [contrNo, setContrNo] = useState(null);

  const onHiding = () => {
    setAOSPTCBillingTimingPopupVisible(false);
  };

  return (
    <Popup
      visible={AOSPTCBillingTimingPopupVisible}
      dragEnabled={false}
      hideOnOutsideClick={false}
      showCloseButton={true}
      showTitle={true}
      title="AOS/PTC 청구시기"
      height={"auto"}
      onHiding={onHiding}
    >
      <Box direction="row" width={"100%"}>
        <Item ratio={2}>
          <div
            style={{
              paddingRight: "16px",
            }}
          >
            <div>청구시기</div>
            <BillingTimingGrid setContrNo={setContrNo} />
          </div>
        </Item>
        <Item ratio={1}>
          <div>Comment {contrNo ? `: (${contrNo})` : ``}</div>
          <CommentGrid contrNo={contrNo} />
        </Item>
      </Box>
    </Popup>
  );
}
